var semver = require('semver');

module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonwebtoken/lib/psSupported.js
// module id = 572
// module chunks = 135